import { Card, Checkbox, Divider, Stack, Typography } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { LocationMinimal } from './ConnectAssortmentsDialog';

interface Props {
  unconnectedLocations: LocationMinimal[];
  checkedLocations: LocationMinimal[];
  handleToggleLocation: (location: LocationMinimal) => void;
  disabled?: boolean;
}

export function UnconnectedLocationsCard({
  unconnectedLocations,
  checkedLocations,
  handleToggleLocation,
  disabled,
}: Props) {
  const t = useMyAssortmentTFunction();

  return (
    <Card
      variant="outlined"
      sx={{
        width: 'fit-content',
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        maxWidth: 270,
        justifyContent: 'space-between',
        gap: 2,
        py: 1,
        px: 2,
        borderStyle: 'dashed',
      }}
    >
      <Stack
        display="grid"
        gridTemplateRows="0.5fr 0.1fr 1fr"
        height="100%"
        gap={2}
        alignItems="start"
      >
        <Stack gap={0.5}>
          <Typography variant="subtitle2">
            {t('myAssortment.memberConfig.unconnectedLocations')}
          </Typography>
        </Stack>
        <Divider />
        <Stack justifyContent="flex-start">
          <Typography variant="body2">{t('myAssortment.memberConfig.locations')}</Typography>
          {unconnectedLocations.map((location) => {
            return (
              <Stack key={location.id} flexDirection="row" gap={1} alignItems="center">
                <Checkbox
                  value={location.id}
                  disabled={disabled}
                  checked={checkedLocations.map((loc) => loc.id).includes(location.id)}
                  onClick={() => handleToggleLocation(location)}
                />
                <Typography variant="subtitle2">{location.name}</Typography>
              </Stack>
            );
          })}
        </Stack>
      </Stack>
    </Card>
  );
}
